import type { UsageProductVariantInput, UsageProductVariant } from '@vy/types';
import React from 'react';
import { UsageProductVariantHeaderEdit } from './UsageProductVariantHeaderEdit';

type UsageProductVariantHeaderProps = {
  className?: string;
  productIndex: number;
  productVariant: UsageProductVariantInput | UsageProductVariant;
  productVariantIndex: number;
};

export const UsageProductVariantHeader: React.FC<UsageProductVariantHeaderProps> = ({
  productIndex,
  productVariant,
  productVariantIndex,
  className,
}) => {
  return (
    <div className={className}>
      <UsageProductVariantHeaderEdit
        productIndex={productIndex}
        productVariant={productVariant}
        productVariantIndex={productVariantIndex}
      />
    </div>
  );
};
